import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { createContract } from "../../../modules/contract/action";
import "../../../style";
import { formatDate } from "../../../utils/DateFormatter";
import ContractForm from "./ContractForm";




class CreateContract extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contractInfo: {
        farmId: this.props.SubFarmId
          ? this.props.SubFarmId
          : userFarmDetail().id || this.props.MainFarmId,
        contractNumber: "", //long
        contractTypeId: "", //long
        maturityDate: formatDate(new Date()),
        counterpartId: "", //long
        destinationId: "", //long
        contractStageId: "",
        commodityId: "", //long
        commodityVarietyId: "", //long
        bushelContracted: "", //float
        unitPrice: "", //float
        basis: "", //float
        notes: ""
      },
      successMessage: "",
      isValid: true
    };
  }

  // componentWillMount() {
  //   // const destinationType = 'External'
  //   const timestamp = Date.now();
  //   let id = this.props.SubFarmId ? this.props.SubFarmId : userFarmDetail().id;
  //   this.setState(prevState => {
  //     return {
  //       contractInfo: {
  //         ...prevState.contractInfo,
  //         ["contractNumber"]: `CN${id}${timestamp}`
  //       }
  //     };
  //   });
  // }

  componentWillReceiveProps(nextProps) {
    if (nextProps.contractCreated && nextProps.contractCreated.status === 200) {
      this.setState({ successMessage: true });
    }
    // if (nextProps.SubFarmId && nextProps.SubFarmId !== this.props.SubFarmId) {
    //   this.setState(prevState => {
    //     return {
    //       contractInfo: {
    //         ...prevState.contractInfo,
    //         farmId: nextProps.SubFarmId
    //       }
    //     };
    //   });
    // }
  }

  // handleChange = (name, value) => {
  //   if (name === "bushelContracted" || name === "unitPrice") {
  //     if (value.match(/^\d{0,10}(\.\d{0,2})?$/)) {
  //       this.setState(prevState => {
  //         return {
  //           contractInfo: {
  //             ...prevState.contractInfo,
  //             [name]: value
  //           }
  //         };
  //       });
  //     }
  //   } else if (name === "basis") {
  //     if (value.match(/^[-]?\d{0,10}(\.\d{0,2})?$/)) {
  //       this.setState(prevState => {
  //         return {
  //           contractInfo: {
  //             ...prevState.contractInfo,
  //             [name]: value
  //           }
  //         };
  //       });
  //     }
  //   } else {
  //     this.setState(prevState => {
  //       return {
  //         contractInfo: {
  //           ...prevState.contractInfo,
  //           [name]: value
  //         }
  //       };
  //     });
  //   }
  // };

  createContract = contractInfo => {
    //e.preventDefault();
    // const { contractInfo } = this.state;
    this.props.actions.createContract(contractInfo);
  };

  render() {
    const { contractInfo, successMessage } = this.state;

    if (successMessage) {
      return <Redirect to="/app/contracts" />;
    }

    return (
      <ContractForm
        formLabel="New Contract"
        buttonLabel="Save Contract"
        contractInfo={contractInfo}
        changeFunction={this.handleChange}
        submitFunction={this.createContract}
      />
    );
  }
}
function mapStateToProps(state) {
  return {
    contractCreated: state.contractReducer.contractCreated,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        createContract
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateContract);



// WEBPACK FOOTER //
// ./src/components/private/Contracts/CreateContract.js